module.exports = __webpack_public_path__ + "static/media/XIN-ZHANG.500d46d3.png";